import { render, staticRenderFns, recyclableRender, components } from "./tn-loading.vue?vue&type=template&id=198243dd&scoped=true&"
var renderjs
import script from "./tn-loading.vue?vue&type=script&lang=js&"
export * from "./tn-loading.vue?vue&type=script&lang=js&"
import style0 from "./tn-loading.vue?vue&type=style&index=0&id=198243dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../软件/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198243dd",
  null,
  false,
  components,
  renderjs
)

export default component.exports